<template>
  <div class="media-container" :class="{'full-screen': fullScreen}">
    <video v-if="lesson.type == 'video'" :src="lesson.file" controls style="height 100%; width: 100%"></video>
    <audio ref="aplayer" width="100%" height="380" v-else-if="lesson.type == 'audio'" controls controlsList="nodownload">
      <source :src="lesson.file" />
    </audio>
    <iframe  v-else-if="lesson.type == 'pdf' || lesson.type == 'file'" :src="lesson.file + '#toolbar=0&navpanes=0'" class="pdfs" height="100%" onload="this.height=100%;this.width=100%;" frameborder="0" allow="fullscreen" />
    <iframe v-else-if="lesson.type == 'youtube'" width="100%" height="100%"   :src="youtubeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <iframe v-else-if="lesson.type == 'iframe'" :style="{'height': fullScreen ? '100vh' : '50vh' }" frameborder="0" width="100%" height="100%" :src="iframeUrl" onload="this.height=100%;this.width=100%;"></iframe>
  </div>
</template>

<script>
import lessonResource from "@/components/lessonResource";
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import raffleHub from "@/services/hubs/raffle";
const NOTE_STORE = "ClientNotes";
export default {
  props: ["lesson", "fullScreen"],
  components: {
    lessonResource
  },
  data() {
    return {
      maxScreen: false,
      tabSelected: "info",
      note: {
        lesson: this.lesson_id
      },
      color: ""
    };
  },
  methods: {
    saveNote() {
      if (this.note.id && !this.note.text) {
        this.note.destroy();
        this.note = { lesson: this.lesson_id };
        return;
      }
      dataStore.cSave(NOTE_STORE, this.note).then(note => {
        this.note = note;
      });
      snackbar.update("Saved");
    },
    complete() {
      this.$emit("complete");
      raffleHub.update("lesson");
      if (this.next) {
        this.$router.push({
          name: "clientLessonDetail",
          params: { id: this.next.module, lesson: this.next.id }
        });
      }
    }
  },
  watch: {
    lesson() {
      try {
        this.$refs.aplayer.load();
      } catch (e) {
      }
    }
  },
  computed: {
    youtubeUrl() {
      // https://youtube.com/watch?v=<id>
      let reg = /v=(.*?)($|&)/g;
      let link = reg.exec(this.lesson.iframe_url);
      if (!link) {
        // https://youtu.be/<id>
        reg = /youtu\.be\/(.+)/g;
        link = reg.exec(this.lesson.iframe_url);
      }
      if (link) {
        link = link[1];
        return `https://www.youtube.com/embed/${link}`;
      }
      return this.lesson.iframe_url;
    },
    iframeUrl() {
      if (this.lesson.type === "iframe") {
        let match = /src="([^ ]+)"/g.exec(this.lesson.iframe_url)
        if (match) {
          return match[1];
        }
      }
      return this.lesson.iframe_url;
    }
  }
};
</script>
